<template>
  <div class="nav">
      <div class="top_nav">
        <div class="box" v-if="classList.length">
          <div class="top_nav_describe">分类：</div>
          <input type="hidden" value="10" />
          <ul class="college_box">
            <li :class="{'active': !value.faceClassId}" @click="clickClass(null)">
              <a
                href="javascript:;"
                class="college"
                >全部</a
              >
            </li>
            <li :class="{'active': item.id === value.faceClassId}" v-for="(item, i) in classList" :key="i" @click="clickClass(item.id)">
              <a
                href="javascript:;"
                class="college"
                >{{item.name}}</a
              >
            </li>
          </ul>
        </div>

        <div class="box">
          <div class="top_nav_describe">年份：</div>
          <ul class="college_box">
            <li :class="{'active': !value.year}" @click="clickYear(null)">
              <a
                href="javascript:;"
                class="college"
                >全部</a
              >
            </li>
            <li :class="{'active': item.period === value.year}" v-for="(item, i) in yearList" :key="i" @click="clickYear(item.period)">
              <a
                href="javascript:;"
                class="college"
                >{{item.period}}</a
              >
            </li>
          </ul>
        </div>
        <div class="box">
          <div class="top_nav_describe">学时：</div>
          <ul class="college_box">
            <li :class="{'active': !value.period}" @click="clickHour(null)">
              <a
                href="javascript:;"
                class="college"
                >全部</a
              >
            </li>
            <li :class="{'active': item.period === value.period}" v-for="(item, i) in hourList" :key="i" @click="clickHour(item.period)">
              <a
                href="javascript:;"
                class="college"
                >{{item.period}}学时</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
import { getFaceClassListPage, getClassHourListPage, getClassYearListPage } from '@/api/face'
export default {
  name: 'Nav',
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          faceClassId: null,
          year: null,
          period: null
        }
      }
    }
  },
  data () {
    return {
      classList: [],
      yearList: [],
      hourList: []
      // value: {
      //   faceClassId: null,
      //   year: null,
      //   period: null
      // }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      Promise.all([getFaceClassListPage(), getClassYearListPage(), getClassHourListPage()]).then(res => {
        this.classList = res[0].data?.records
        this.yearList = res[1].data || []
        this.hourList = res[2].data || []
      })
    },
    clickClass (id) {
      this.$emit('input', { ...this.value, faceClassId: id })
      this.$parent.reset()
    },
    clickYear (id) {
      this.$emit('input', { ...this.value, year: id })
      this.$parent.reset()
    },
    clickHour (id) {
      this.$emit('input', { ...this.value, period: id })
      this.$parent.reset()
    }
  }
}
</script>

<style lang="scss" scoped>

.top_nav {
  .box:nth-child(3) {
    border-bottom: none !important;
  }
}

a {
  text-decoration: none;
}
.nav {
  background-color: #F2F2F2;
  margin: 0 20px;
}
.top_nav {
  font-weight: 400;
  line-height: 25px;
  overflow: hidden;
  background: #F2F2F2;
  border: 1px solid #eeeeee;
  margin-bottom: 25px;
}
.top_nav > div {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0;
  position: relative;
}
.top_nav ul {
  clear: both;
  overflow: hidden;
  padding-left: 36px;
}
.top_nav ul li,
.top_nav .top_nav_describe {
  float: left;
  text-align: center;
  height: 24px;
  line-height: 24px;
  margin-right: 30px;
  font-size: 14px;
  margin: 10px 0;
  border-radius: 14px;
}
.top_nav .top_nav_describe {
  width: 60px;
}
.top_nav ul li {
  padding: 0 14px;
  margin-left: 20px;
}
.top_nav ul li:hover a {
  color: #208ff8;
}

.top_nav ul li.active a {
  color: #fff;
}
.top_nav ul li.active a:hover {
  color: #fff;
}
.top_nav ul li.region_list {
  text-align: center;
}
.top_nav ul li.active {
  background: linear-gradient(90deg, #0F59BE 0%, #4A6EEF 100%);
  border-radius: 11px;
}
.top_nav ul li.region_list.active a {
  color: #fff;
}
.top_nav ul li.region_list a {
  color: #333;
}
.top_nav ul li.region_list a:hover {
  color: #0F59BE;
}
div.top_nav ul li.active a:hover {
  color: #fff;
}
.top_nav .top_nav_describe {
  /* width: 100%; */
  text-align: center;
  padding: 10px 31px 10px 0;
  /* padding-left: 36px; */
  /* border-bottom: 1px solid #eee; */
  margin: 0;
  padding-right: 10px;
  position: absolute;
}
.top_nav_describe > a {
  color: #333;
}
.top_nav ul li .college {
  color: #333;
}
.top_nav ul.college_box {
  /* width: 1164px; */
  /* border-bottom: 1px solid #EEEEEE; */
  // margin-left: 65px;
}
.box {
  margin: 0 24px 0 6px;
  border-bottom: 1px dashed #c6c6c6 !important;
}
</style>
